import { ISettingInfo, IWritableSettings, ObjectHelper } from '@barthauer/abc/core';

export enum ArenaSetting {
  gridLayouts,
  parameters,
}

export interface IArenaSettings {
  readonly gridLayouts: {};
  readonly parameters: {};
}

export class ArenaSettings implements IArenaSettings, IWritableSettings<IArenaSettings> {
  public static readonly Infos: ReadonlyMap<ArenaSetting, ISettingInfo> = new Map<ArenaSetting, ISettingInfo>([
    [
      ArenaSetting.gridLayouts,
      { settingName: ObjectHelper.nameof<IArenaSettings>('gridLayouts'), responsePropertyName: ObjectHelper.nameof<IArenaSettings>('gridLayouts'), settingValueType: Object },
    ],
    [
      ArenaSetting.parameters,
      { settingName: ObjectHelper.nameof<IArenaSettings>('parameters'), responsePropertyName: ObjectHelper.nameof<IArenaSettings>('parameters'), settingValueType: Object },
    ],
  ]);

  gridLayouts: {} = {};
  parameters: {} = {};

  load(settings: IArenaSettings): void {
    this.gridLayouts = settings?.gridLayouts ?? {};
    this.parameters = settings?.parameters ?? {};
  }
}
